export default "__VITE_ASSET__CK7DWk9F__"